module.exports = __webpack_public_path__ + "img/Burger-Menu.d770ec7a.svg";